import React from 'react';

interface DashboardCardProps {
    title: string;
    className?: string;
    children?: React.ReactNode;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ title, className, children }) => (
    <div className={className ? `ad-card ${className}` : 'ad-card'}>
        <h3 className="ad-card-title">{title}</h3>
        {children}
    </div>
);

export default DashboardCard;
